var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.727273C0 0.325611 0.325611 0 0.727273 0H10.9091C11.3108 0 11.6364 0.325611 11.6364 0.727273V10.9091C11.6364 11.3108 11.3108 11.6364 10.9091 11.6364H0.727273C0.325611 11.6364 0 11.3108 0 10.9091V0.727273ZM1.45455 1.45455V10.1818H10.1818V1.45455H1.45455ZM13.0909 5.09091C13.0909 4.68925 13.4165 4.36364 13.8182 4.36364H15.2727C15.6744 4.36364 16 4.68925 16 5.09091V15.2727C16 15.6744 15.6744 16 15.2727 16H5.09091C4.68925 16 4.36364 15.6744 4.36364 15.2727V13.8182C4.36364 13.4165 4.68925 13.0909 5.09091 13.0909C5.49257 13.0909 5.81818 13.4165 5.81818 13.8182V14.5455H14.5455V5.81818H13.8182C13.4165 5.81818 13.0909 5.49257 13.0909 5.09091Z",
    fill: "#EEF9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.e29e63c6d09c1c1e4d43fdfcb9a554af.svg";
export { ForwardRef as ReactComponent };